import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import { colors } from '../../utils';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    paper: {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column'
    },
    tableHeader: {
      background: colors.defaultGrey
    },
    tableHeaderFooter: {
      background: colors.defaultGrey
    },
    tableRowArrowCell: {
      paddingBottom: 0,
      paddingTop: 0
    },
    paperHeader: {
      justifyContent: 'space-between'
    },
    justifyRight: {
      justifyContent: 'flex-end',
      alignItems: 'center'
    },
    withMarginLeft: {
      marginLeft: theme.spacing(1)
    },
    tableInfoChip: {
      marginLeft: theme.spacing(2),
      background: colors.defaultGrey
    }
  });
});
